import { render, staticRenderFns } from "./MainModalContainer.vue?vue&type=template&id=61a353f7&scoped=true&"
import script from "./MainModalContainer.vue?vue&type=script&lang=js&"
export * from "./MainModalContainer.vue?vue&type=script&lang=js&"
import style0 from "./MainModalContainer.vue?vue&type=style&index=0&id=61a353f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a353f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a353f7')) {
      api.createRecord('61a353f7', component.options)
    } else {
      api.reload('61a353f7', component.options)
    }
    module.hot.accept("./MainModalContainer.vue?vue&type=template&id=61a353f7&scoped=true&", function () {
      api.rerender('61a353f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/MainModalContainer.vue"
export default component.exports